import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTheme } from '@emotion/react';
import { IconContainer } from '../../Icon/index.js';
import { FlexContainer } from '../../CSS/index.js';
const SIZE_TO_ICON_SIZE = {
    small: {
        width: 10,
        height: 15
    },
    medium: {
        width: 20,
        height: 15
    },
    large: {
        width: 20,
        height: 15
    }
};
const ButtonContent = props => {
    const theme = useTheme();
    const { size = 'small', icon, color: customColor, children, iconPosition = 'left' } = props;
    const color = typeof customColor === 'function' ? customColor(theme) : customColor;
    switch (iconPosition) {
        case 'right':
            return (_jsxs(FlexContainer, { style: { alignItems: 'center', gap: 7 }, children: [children, icon && (_jsx(IconContainer, { style: theme => ({
                            ...SIZE_TO_ICON_SIZE[size],
                            color: color || theme.primaryAccentColor
                        }), children: icon }))] }));
        case 'left':
        default:
            return (_jsxs(FlexContainer, { style: { alignItems: 'center', gap: 7 }, children: [icon && (_jsx(IconContainer, { style: theme => ({
                            ...SIZE_TO_ICON_SIZE[size],
                            color: color || theme.primaryAccentColor
                        }), children: icon })), children] }));
    }
};
export default ButtonContent;
//# sourceMappingURL=index.js.map